import React, { useCallback } from 'react';
import { AddComment } from 'lib/comments-common';
import SectionDropdown from './SectionDropdown/SectionDropdown';
import { useSubmitHandlers } from './hooks/useSubmitHandlers';
const AddCommentContainer: React.FC = () => {
  const { handleSubmit } = useSubmitHandlers();
  const customMentionRenderer = useCallback((user: any) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <span style={{ fontWeight: 500 }}>{user.name}</span>
        <span style={{ color: '#666', fontSize: '0.9em' }}>
          ({user.username})
        </span>
      </div>
    );
  }, []);
  return (
    <AddComment
      onSubmit={handleSubmit}
      style={{
        gap: '0px'
      }}
      containerStyle={{
        padding: 0
      }}
      labelConfig={{
        layout: 'horizontal',
        children: <SectionDropdown />
      }}
      inputConfig={
        {
          maxSuggestions: 50,
          usersApiEndpoint: `${process.env.REACT_APP_API_V2_URL}/ldap/users`,
          mentionPopupDisplay: customMentionRenderer
        } as any
      }
    />
  );
};

export default AddCommentContainer;
